var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-tmpl"},[_c('div',{staticClass:"audio-btn",on:{"click":_vm.audioSwitch}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"audio-box"},[_c('audio',{attrs:{"src":_vm.url,"controls":"controls","controlslist":"nodownload","preload":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }